import React, { useState, useEffect, useRef } from "react";
import { GetLivetv } from "../../Model/Content"; //Include Home
import "videojs-contrib-quality-levels";
import { motion } from "framer-motion";
import { LiveTVplayer } from "../../components/vidjs/mainPlayer";
import $ from "jquery";
import BarLoader from "react-spinners/BarLoader";
import { Link, useNavigate } from "react-router-dom";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { userprofile } from "../../Model/Users";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

export function Playlivetv() {
  const [contentdata, setContent] = useState(0);
  const [dataloaded, setDataloaded] = useState(false);
  const navigate = useNavigate();
  var Keywords;

  useEffect(() => {
    let data = {
      seesionID:localStorage.getItem("session_id"),
      userID:localStorage.getItem("userID")
    }
    userprofile(data).then((userDatares) => {
      if (JSON.parse(userDatares.data.message).success == false) {
        navigate("/createaccount");
      }
    });
    GetLivetv().then((res) => {
      if (res.data.message && res.data.message == "session_expired") {
        navigate("/createaccount");
      }

      var LiveTVdata = JSON.parse(res.data.message.body);

      if (LiveTVdata.contents) {
        setDataloaded(true);
        setContent(LiveTVdata);
      } else {
        setDataloaded(false);
      }
    });
  }, []);
  /*---------------*/

  /*---------------*/
  const formatAMPM = (date) => {
    var ss = new Date(date);
    let hours = ss.getUTCHours();

    let minutes = ss.getUTCMinutes();
    const ampm = hours >= 12 ? "pm" : "am";

    hours %= 12;
    hours = hours || 12;
    minutes = minutes < 10 ? `0${minutes}` : minutes;

    const strTime = `${hours}:${minutes} ${ampm}`;

    return strTime;
  };

  let idleTimer = null;
  let idleState = false;

  function showFoo(time) {
    clearTimeout(idleTimer);
    if (idleState == true) {
      $("#div1").removeClass("inactive");
    }
    idleState = false;
    idleTimer = setTimeout(function () {
      $("#div1").addClass("inactive");
      idleState = true;
    }, time);
  }

  showFoo(2000);
  let clsebtn = () => {
    window.history.go(-1);
  };
  $(window).mousemove(function () {
    showFoo(2000);
  });

  if (dataloaded == false) {
    //return <div className="loader"></div>;
    return (
      <div className="loader">
        <BarLoader color="#ff000f" />
      </div>
    );
  } else {
    if (contentdata.live_tv.keywords) {
      Keywords = contentdata.live_tv.keywords.split(",");
      Keywords = <div className="lBay">{Keywords[0]}</div>;
    }

    return (
      <>
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          key="1"
        >
          <div id="LiveTVplayer">
            <LiveTVplayer
              data={contentdata.live_tv.live_app_url}
              post={contentdata.live_tv.thumbnail_image2.small}
              content={contentdata}
              autoplay={true}
              loader={true}
              functionclose={clsebtn}
            />
          </div>
        </motion.div>
      </>
    );
  }
}
